module.exports = __webpack_public_path__ + "img/R4DM24_valostore_logo.62ee4aff.png";